<template>
  <div v-if="!ready">
    <loading />
  </div>
  <div v-else>
    <TaxInvoiceOrgTcm
      v-if="featureFlags.orgTcm"
      :isCategorized='false'
      :selectedPatient="selectedPatient"
      :print="print"
      :general="generalConfig"
      :printConfig="invoiceConfig.printing"
      :virtualCurrencyConfig="virtualCurrencyConfig"
      :membershipConfig="membershipConfig"
      :convertToVirtualCurrency="convertToVirtualCurrency"
      :includeGST="invoiceConfig.includeGST"
      :invoiceConfig="invoiceConfig"
      :roundOff="roundingMethod"
      :redeem="redeem"
      :multipleICD10Enabled="patientConfig.multipleICD10Recording"
      :inventoryConfig="inventoryConfig"
      @print="removeInvoiceFromInvoicePrintMap"
    />
    <TaxInvoiceMakaung
      v-else-if="featureFlags.isMaKuang"
      :isCategorized='false'
      :selectedPatient="selectedPatient"
      :print="print"
      :general="generalConfig"
      :printConfig="invoiceConfig.printing"
      :virtualCurrencyConfig="virtualCurrencyConfig"
      :membershipConfig="membershipConfig"
      :convertToVirtualCurrency="convertToVirtualCurrency"
      :includeGST="invoiceConfig.includeGST"
      :invoiceConfig="invoiceConfig"
      :roundOff="roundingMethod"
      :redeem="redeem"
      :multipleICD10Enabled="patientConfig.multipleICD10Recording"
      :inventoryConfig="inventoryConfig"
      @print="removeInvoiceFromInvoicePrintMap"
    />
    <tax-invoice-tph
      v-else-if="featureFlags.tphInvoice"
      :isCategorized='false'
      :selectedPatient="selectedPatient"
      :print="print"
      :general="generalConfig"
      :printConfig="invoiceConfig.printing"
      :virtualCurrencyConfig="virtualCurrencyConfig"
      :membershipConfig="membershipConfig"
      :convertToVirtualCurrency="convertToVirtualCurrency"
      :includeGST="invoiceConfig.includeGST"
      :roundOff="roundingMethod"
      :redeem="redeem"
      :multipleICD10Enabled="patientConfig.multipleICD10Recording"
      @print="removeInvoiceFromInvoicePrintMap"
    />
    <taxInvoiceNiksOnRoll
      v-else-if="isRoller && featureFlags.niks"
      :isCategorized='false'
      :selectedPatient="selectedPatient"
      :print="print"
      :general="generalConfig"
      :printConfig="invoiceConfig.printing"
      :virtualCurrencyConfig="virtualCurrencyConfig"
      :membershipConfig="membershipConfig"
      :convertToVirtualCurrency="convertToVirtualCurrency"
      :includeGST="invoiceConfig.includeGST"
      :roundOff="roundingMethod"
      :redeem="redeem"
      :multipleICD10Enabled="patientConfig.multipleICD10Recording"
      @print="removeInvoiceFromInvoicePrintMap"
    />
    <tax-invoice-on-roll
      v-else-if="isRoller"
      :isCategorized='false'
      :selectedPatient="selectedPatient"
      :print="print"
      :general="generalConfig"
      :printConfig="invoiceConfig.printing"
      :virtualCurrencyConfig="virtualCurrencyConfig"
      :convertToVirtualCurrency="convertToVirtualCurrency"
      :includeGST="invoiceConfig.includeGST"
      :roundOff="roundingMethod"
      :redeem="redeem"
      :multipleICD10Enabled="patientConfig.multipleICD10Recording"
      @print="removeInvoiceFromInvoicePrintMap"
    />
    <tax-invoice-niks
      v-else-if="featureFlags.niks"
      :isCategorized='false'
      :selectedPatient="selectedPatient"
      :print="print"
      :general="generalConfig"
      :printConfig="invoiceConfig.printing"
      :virtualCurrencyConfig="virtualCurrencyConfig"
      :membershipConfig="membershipConfig"
      :convertToVirtualCurrency="convertToVirtualCurrency"
      :includeGST="invoiceConfig.includeGST"
      :roundOff="roundingMethod"
      :redeem="redeem"
      :multipleICD10Enabled="patientConfig.multipleICD10Recording"
      @print="removeInvoiceFromInvoicePrintMap"
    />
    <tax-invoice-component
      v-else
      :isCategorized='false'
      :selectedPatient="selectedPatient"
      :print="print"
      :general="generalConfig"
      :printConfig="invoiceConfig.printing"
      :virtualCurrencyConfig="virtualCurrencyConfig"
      :membershipConfig="membershipConfig"
      :convertToVirtualCurrency="convertToVirtualCurrency"
      :includeGST="invoiceConfig.includeGST"
      :roundOff="roundingMethod"
      :redeem="redeem"
      :multipleICD10Enabled="patientConfig.multipleICD10Recording"
      @print="removeInvoiceFromInvoicePrintMap"
    />
  </div>
</template>

<script>
import TaxInvoiceComponent from '@/components/Print/TaxInvoiceComponent.vue';
import TaxInvoiceNiks from '@/components/Print/TaxInvoiceNiks.vue';
import TaxInvoiceNiksOnRoll from '@/components/Print/TaxInvoiceNiksOnRoll.vue';
import TaxInvoiceOnRoll from '@/components/Print/TaxInvoiceOnRoll.vue';
import TaxInvoiceTph from '@/components/Print/TaxInvoiceTph.vue';
import computedMixins from '@/components/mixins/computed';
import invoicePrintMixins from '@/components/mixins/invoice-print';
import { mapGetters, mapActions } from 'vuex';
import TaxInvoiceMakaung from '@/components/Print/TaxInvoiceMakung.vue'
import TaxInvoiceOrgTcm from '@/components/Print/TaxInvoiceOrgTcm.vue'
import patientService from '@/services/patient.service';

export default {
  name: 'PrintCategorizedTaxInvoice',
  components: {
    TaxInvoiceComponent,
    TaxInvoiceOnRoll,
    TaxInvoiceTph,
    TaxInvoiceMakaung,
    TaxInvoiceOrgTcm,
    TaxInvoiceNiks,
    TaxInvoiceNiksOnRoll,
  },
  mixins: [computedMixins, invoicePrintMixins],
  data() {
    return {
      ready: false,
      selectedPatient: {},
      convertToVirtualCurrency: false,
    };
  },
  computed: {
    ...mapGetters('config', {
      generalConfig: 'general',
      invoiceConfig: 'invoice',
      patientConfig: 'patient',
      featureFlags: 'featureFlags',
      inventoryConfig: 'inventory',
      virtualCurrencyConfig: 'virtualCurrency',
      membershipConfig: 'membership',
    }),
    roundingMethod() {
      let roundingMethod;
      if (typeof this.print.roundingEnabled === 'undefined') {
        // Use what is on Config when indv setting is not defined
        roundingMethod = this.invoiceConfig.roundOff;
      } else {
        // TODO: for now set to 0.05 rounding when enabled
        // wait for rounding method to be saved to database too
        roundingMethod = this.print.roundingEnabled ? 'ROUND0P05' : 'NONE';
      }
      return roundingMethod;
    },
    redeem() {
      return this.print.items.filter(i => i.redeemedPoint > 0)
        .reduce((a, b) => {
          a.point += b.redeemedPoint;
          a.amount += b.redeemAmountAfterTax;
          return a;
        }, { point: 0, amount: 0 });
    },
    isRoller() {
      const truthyParams = new Set(['1', 'true']);
      return (
        this.$route &&
        this.$route.query &&
        this.$route.query.roller &&
        truthyParams.has(this.$route.query.roller.toLowerCase())
      );
    },
  },
  methods: {
    async fetchPatient() {
      const patientId = this.print.patient?._id ? this.print.patient._id : this.print.patient;
      const res = await patientService.getPatient(patientId);
      if (res.ok) {
        this.selectedPatient = res.data;
      }
    },
    fetchDependencies() {
      return Promise.all([
        this.fetchPatient(),
      ]);
    },
  },
  mounted() {
    if (this.$route.query && this.$route.query['virtual-currency']) {
      this.convertToVirtualCurrency = true;
    }
  },
  async created() {
    this.setInvoiceForPrinting()
    await this.fetchDependencies();
    this.ready = true;
  },
};
</script>
